import React, { useRef } from 'react';
import { Box } from '@components/Box';
import { Text } from '@components/typography';
import ReactHtmlParser from 'react-html-parser';
import { CloudImage } from '@components/CloudImage';
import {
  StyledTextPairing,
  StyledBody,
  DisplayAboveMobileCloudImage,
  DisplayOnMobileCloudImage,
  ContentWrapper,
  StyledFlex,
  TextWrapper,
  StyledColumns,
  StyledColumn,
} from './GiftingSection.styles';
import { useTranslation } from 'react-i18next';

export const GiftingSection: React.FC = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation('babyRegistry');
  const babyRegistryGiftingData = t('giftingGroup');

  return (
    <Box as="section" ref={sectionRef} id="BabyRegistry_GroupGifting" marginTop={[12]}>
      <StyledBody>
        <StyledColumns centered marginBottom={12}>
          <StyledColumn offset={1} width={4}>
            <CloudImage
              alt={babyRegistryGiftingData.gift.title}
              src={'baby-registry/group-gifting/gift.jpg'}
              width="100%"
              css={{ maxWidth: '300px' }}
              optimization="default"
            />
          </StyledColumn>
          <StyledColumn offset={1} width={4}>
            <StyledTextPairing
              marginTop={[8, 0]}
              eyebrow={babyRegistryGiftingData.gift.eyebrow}
              eyebrowColor="neutra4"
              eyebrowVariant="sectionEyeBrow20"
              title={babyRegistryGiftingData.gift.title}
              titleVariant="calloutHed40"
              titleColor="neutra6"
              titleTagName="h3"
              titleMaxWidth="330px"
              body={babyRegistryGiftingData.gift.body}
              bodyVariant="dek20"
              bodyColor="neutra5"
              bodyMaxWidth="407px"
              alignment={['center', 'left']}
            />
          </StyledColumn>
        </StyledColumns>
        <StyledColumns centered>
          <StyledColumn offset={1} width={4}>
            <StyledTextPairing
              marginBottom={[8, 0]}
              eyebrow={babyRegistryGiftingData.thanks.eyebrow}
              eyebrowColor="neutra4"
              eyebrowVariant="sectionEyeBrow20"
              title={babyRegistryGiftingData.thanks.title}
              titleVariant="calloutHed40"
              titleColor="neutra6"
              titleTagName="h3"
              body={babyRegistryGiftingData.thanks.body}
              bodyVariant="dek20"
              bodyColor="neutra5"
              alignment={['center', 'left']}
            />
          </StyledColumn>
          <StyledColumn offset={1} width={4}>
            <CloudImage
              alt={babyRegistryGiftingData.thanks.title}
              src={'baby-registry/thankyou-notes/note-phone.jpg'}
              width="100%"
              css={{ maxWidth: '300px' }}
              optimization="default"
            />
          </StyledColumn>
        </StyledColumns>
      </StyledBody>
      <ContentWrapper justifyContent="flex-start" alignItems="center" marginX={[4, 8]} flexDirection="column">
        <StyledFlex justifyContent="flex-start" alignItems="center" flexDirection="column">
          <TextWrapper flexDirection="column" alignItems="center" paddingTop={[8, 88]}>
            <StyledTextPairing
              eyebrow={babyRegistryGiftingData.shipAnywhere.eyebrow}
              eyebrowColor="green4"
              eyebrowVariant="sectionEyeBrow20"
              title={ReactHtmlParser(babyRegistryGiftingData.shipAnywhere.title)}
              titleVariant="calloutHed40"
              titleColor="neutra6"
              titleTagName="h3"
              body={babyRegistryGiftingData.shipAnywhere.body}
              bodyVariant="dek20"
              bodyColor="neutra5"
              alignment="center"
              bodyMaxWidth="382px"
            />
            <Text variant="caption" tagName="p" color="neutra5">
              {babyRegistryGiftingData.shipAnywhere.note}
            </Text>
          </TextWrapper>
          <DisplayOnMobileCloudImage
            alt={babyRegistryGiftingData.thanks.title}
            src={babyRegistryGiftingData.shipAnywhere.srcMobile}
            width="100%"
            optimization="default"
          />
        </StyledFlex>
        <DisplayAboveMobileCloudImage
          alt={babyRegistryGiftingData.thanks.title}
          src={babyRegistryGiftingData.shipAnywhere.src}
          width="100%"
          optimization="default"
        />
      </ContentWrapper>
    </Box>
  );
};
